import { useState } from "react";
import useRazorpayPayment from "../hooks/useRazorpayPayment";
import Gmailicon from "../assets/img/gmail.png";
import Phoneicon from "../assets/img/phone.png";

const RazorpayModal = ({ id, courseType, title }) => {
  const { payNow } = useRazorpayPayment();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="modal fade" id={id} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <div className="formouter">
              <div className="formcontent">
                <div className="contact_form modalform">
                  <h2> {title} </h2>
                  <div className="row">
                    <div className="col-sm-6">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Your Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-sm-6">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Your Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-sm-6">
                      <input
                        type="number"
                        name="phone"
                        className="form-control"
                        placeholder="Your Phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <button
                    className="btn btn-form"
                    onClick={() =>
                      payNow({
                        courseType,
                        formData,
                        onSuccess: (res) =>
                          (window.location.href = `/success?payment_id=${res.razorpay_payment_id}`),
                      })
                    }
                  >
                    Enroll Now
                  </button>
                </div>
              </div>
              <div className="forminfo">
                
                {/* <a href="tel:919899604722">
                                            <img src={Phoneicon} alt="" /> +91-9899604722
                                          </a>
                                          <a href="mailto:infobhavanasingh@gmail.com">
                                            <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
                                          </a> */}
              </div>
            </div> 
            <div className="contact_bottom">
              <a href="tel:919899604722">
                <img src={Phoneicon} alt="Phone" /> +91 - 9899604722
              </a>
              <a href="mailto:infobhavanasingh@gmail.com">
                <img src={Gmailicon} alt="Email" className="emailbrn" />
                Infobhavanasingh@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RazorpayModal;
